import { render, staticRenderFns } from "./BsnPlnReg.vue?vue&type=template&id=424ee254&"
import script from "./BsnPlnReg.vue?vue&type=script&lang=js&"
export * from "./BsnPlnReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports